<template>
  <div>
    <div class="box">
      <div class="pict">
        <a @click="authentication()">
          <img src="/image/btn_google_signin_dark_normal_web@2x.png" />
        </a>
      </div>
      <div class="text">
        <span>Google Fit から歩数取得</span>
      </div>
    </div>
    <a @click="openPDF('for_googlefit_stepcount')">
      <v-icon color="info" class="info-btn">
        mdi-information-outline
      </v-icon>
    </a>
  </div>
</template>

<script>
import GraphqlAPI from '../../../utils/GraphqlAPI'
import axios from 'axios'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')

const convertArrayString = (arrayData) => {
  const resArry = arrayData.map(obj => {
    const arr = Object.keys(obj).map(key => {
      if (obj[key] instanceof Array) {
        const courseArry = obj[key]
        const arr2 = courseArry.map(obj2 => {
          const objStr = Object.keys(obj2).map(key2 => {
            if (obj2[key2] === 0 || obj2[key2]) {
              if (typeof obj2[key2] === 'number' || typeof obj2[key2] === 'boolean') {
                return `${key2}: ${obj2[key2]}`
              } else {
                return `${key2}: "${obj2[key2]}"`
              }
            }
          })
          return `{${objStr.join(', ')}}`
        })
        const arr2str = `[${arr2.join(', ')}]`
        return `${key}: ${arr2str}`
      } else if (typeof obj[key] === 'number' || typeof obj[key] === 'boolean') {
        return `${key}: ${obj[key]}`
      } else if (obj[key]) {
        return `${key}: ${JSON.stringify(obj[key])}`
      }
    })
    return `{${arr.join(', ')}}`
  })
  return `[${resArry.join(', ')}]`
}

const convertObjString = (obj) => {
  const arr = Object.keys(obj).map((key) => {
    if (typeof obj[key] === 'number' || typeof obj[key] === 'boolean') {
      return `${key}: ${obj[key]}`
    }
  })
  return `{${arr.join(',')}}`
}

const saveResultMutation = (campaignId, dailyResultInputList, saveResultInputOption) => `
  mutation saveResult {
    saveResult(
      input: {
        campaign_id: "${campaignId}",
        daily_result: ${convertArrayString(dailyResultInputList)},
        save_result_option: ${convertObjString(saveResultInputOption)}
      }
    )
  }
`
const saveResult = async (campaignId, dailyResultInputList, saveResultInputOption) => {
  const { data: { saveResult: data } } = await GraphqlAPI(saveResultMutation(campaignId, dailyResultInputList, saveResultInputOption))
  return data
}

export default {
  props: [
    'dailyValueList',
    'campaignUser',
    'isSubmitting',
    'stepCountIntegrateCourseId'
  ],
  data () {
    return {
      accessToken: null,
      targetDateList: []
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  mounted () {
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://accounts.google.com/gsi/client')
    document.head.appendChild(recaptchaScript)
  },
  methods: {
    // 認証
    async authentication () {
      const client = window.google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_FIT_CLIENT_ID,
        scope: 'https://www.googleapis.com/auth/fitness.activity.read'
      })
      const tokenResponse = await new Promise((resolve, reject) => {
        try {
          client.callback = (resp) => {
            if (resp.error !== undefined) {
              reject(resp)
              console.error(resp.error)
              this.$emit('inputErrorFromGoogleFit', 'GoogleFitとの連携に失敗しました。')
            }
            resolve(resp)
            this.authorization(resp.access_token)
          }
          client.requestAccessToken({ prompt: 'consent' })
        } catch (err) {
          console.error(err)
          this.$emit('inputErrorFromGoogleFit', 'GoogleFitとの連携に失敗しました。')
        }
      })
      return tokenResponse
    },
    // 認可
    async authorization (accessToken) {
      try {
        this.$emit('googleAPISubmitting', true)
        const startDate = dayjs(this.campaign.start).valueOf()
        const endDate = ((dayjs() < dayjs(this.campaign.end)) ? dayjs() : dayjs(this.campaign.end).add(1, 'day')).valueOf()
        const MAX_DAYS_MILLIS = 7776000000 // 90日間

        if (endDate - startDate < MAX_DAYS_MILLIS) {
          this.saveData(await this.kickAPI(startDate, endDate, accessToken))
        } else {
          // 取得期間が90日よりも長い場合は、90日毎に分割して取得する
          let tempStartDate = startDate
          let tempEndDate
          let pointList = []
          while (endDate > tempStartDate) {
            tempEndDate = tempStartDate + MAX_DAYS_MILLIS - 1
            pointList = [...pointList, ...(await this.kickAPI(tempStartDate, tempEndDate, accessToken))]
            tempStartDate += MAX_DAYS_MILLIS
          }
          this.saveData(pointList)
        }
      } catch (e) {
        this.$emit('googleAPISubmitting', false)
        if (e.error === 'popup_closed_by_user') {
          // ユーザがポップアップを閉じたとき。何もしない
          return null
        }
        console.error(e)
        this.$emit('inputErrorFromGoogleFit', 'GoogleFitとの連携に失敗しました。')
        return null
      }
    },
    async kickAPI (start, end, token) {
      return axios.post('https://www.googleapis.com/fitness/v1/users/me/dataset:aggregate?access_token=' + token,
        {
          aggregateBy: [{
            dataTypeName: 'com.google.step_count.delta',
            dataSourceId: 'derived:com.google.step_count.delta:com.google.android.gms:estimated_steps'
          }],
          bucketByTime: { durationMillis: 86400000 },
          startTimeMillis: start,
          endTimeMillis: end
        })
        .then(response => {
          const pointList = []
          response.data.bucket.forEach(data => {
            const date = dayjs(data.startTimeMillis * 1).format('YYYY-MM-DD')
            const points = data.dataset[0].point
            pointList.push({ date: date, point: points.length > 0 ? points[0].value[0].intVal : 0 })
          })
          return pointList
        })
        .catch(error => {
          this.$emit('googleAPISubmitting', false)
          console.error(error)
          this.$emit('inputErrorFromGoogleFit', 'エラーが発生しました。GoogleFitと連携済みのGoogleアカウントであることを確認してください。')
          return null
        })
    },
    async saveData (pointList) {
      const updateDailyValueList = []
      this.dailyValueList.forEach(elm => {
        // 手動入力されたデータは、上書き用データを作成しない。
        if (elm.select_course_result.find(cr => cr.course_id === this.stepCountIntegrateCourseId).is_manual) {
          return // continueする
        }
        const wp = pointList.find(point => {
          return point.date === elm.date
        })
        // 更新対象
        const filteredCourseList = []
        for (const ce of elm.select_course_result) {
          if (ce.course_id === this.stepCountIntegrateCourseId) {
            filteredCourseList.push({
              course_id: ce.course_id,
              circle_and_cross: null,
              integer: typeof wp === 'undefined' || wp.point === 0 ? null : wp.point,
              number: null,
              is_manual: false
            })
          } else {
            filteredCourseList.push({
              course_id: ce.course_id,
              circle_and_cross: ce.circle_and_cross,
              integer: (ce.integer === 0 || ce.integer) ? parseInt(ce.integer) : null,
              number: (ce.number === 0 || ce.number) ? parseFloat(ce.number) : null
            })
          }
        }
        const newDv = {}
        if (elm.top_blood_pressure || elm.bottom_blood_pressure || elm.note || (filteredCourseList && filteredCourseList.length > 0)) {
          newDv.date = elm.date
          newDv.top_blood_pressure = elm.top_blood_pressure ? parseInt(elm.top_blood_pressure) : null
          newDv.bottom_blood_pressure = elm.bottom_blood_pressure ? parseInt(elm.bottom_blood_pressure) : null
          newDv.note = elm.note ? elm.note : null
          newDv.select_course_result = filteredCourseList
          updateDailyValueList.push(newDv)
        }
      })
      try {
        await saveResult(this.campaign.id, updateDailyValueList, {})
        await this.$emit('fetchDataFromGoogleFit')
        this.updateDailyValueList = []
      } catch (e) {
        this.$emit('inputErrorFromGoogleFit', '結果記録の保存に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
        this.$emit('googleAPISubmitting', false)
      }
    },
    openPDF (target) {
      window.open('/manual/' + target + '.pdf', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  display: flex;
  flex-direction: column;
  float: left;
  margin: 10px 12px 8px;
}
.pict {
  text-align: center;
  height: 39px;
}
.pict img {
  height: 100%;
}
.text {
  text-align: center;
  font-size: 0.725rem;
}
.info-btn {
  margin: 18px 0;
}

@media (max-width: 959px) {
  .box {
    display: flex;
    flex-direction: column;
    float: left;
    margin: 7px 4px;
  }
  .pict {
    height: 31px;
  }
  .info-btn {
    margin: 10px 0;
  }
}
</style>
